<template>
  <div class="wrapper">
    <div class="main-title">
      <div>
        <img src="@/assets/k3.svg" width="150px" height="150px" />
      </div>
      <div>
        <span class="name">Kadra Cube</span>
      </div>
      <div>
        <span class="desc"
          >We help your business increase efficiency through software</span
        >
      </div>
      <div>
        <a class="mail" href="mailto:contact@kadracube.com"
          >contact@kadracube.com</a
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Home"
};
</script>

<style lang="scss" scoped>
.wrapper {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}
.main-title {
  display: flex;
  flex-direction: column;
}
.name {
  font-size: 5rem;
  font-weight: 700;
  font-style: italic;
  text-shadow: 4px 2px #880023;
}
.desc {
  font-size: 1.5rem;
}
.mail {
  color: #e2003b;
}
</style>
